<template>
  <v-form ref="form" class="py-3">
    <div class="tertiary--text text-body-2">
      {{ 
        $t(
        'fleet_management.agents.create.labels.create_agent_form_rpm_excessive'
        )
      }}
    </div>
    <v-text-field
      id="idEventosExcesivoRPM"
      v-model.number="rpm_limit"
      dense
      filled
      min="600"
      max="10000"
      :readonly="!editMode"
      hide-details="auto"
      :rules="rpmExcessiveRules"
      type="number"
      @input="rpmEmit"
    ></v-text-field>
  </v-form>
</template>

<script>
import { i18n } from '@leapsight/portal'

export default {
  name: 'RpmExcessive',
  props: {
    editMode: {
      type: Boolean,
      default: false
    },
    dataProp: {
      type: Object
    }
  },
  data() {
    return {
      rpm_limit: 1500,
      rpmExcessiveRules: [
        v =>
          (v !== null && v !== undefined && v !== '') ||
          i18n.t('fleet_management.agents.create.errors.ralenti_rpm_limit_empty'),
        v =>
          (v >= 600 && v <= 10000) ||
          i18n.t('fleet_management.agents.create.errors.rpm_excessive_range_error')
      ]
    }
  },
  methods: {
    rpmEmit() {
      this.$emit('rpmExcessive', this.rpm_limit)
      this.validationsRpmExcessive()

      if (this.rpm_limit !== '') this.$refs.form.validate()
    },
    validationsRpmExcessive() {
      const validRpmExcessiveValues = this.rpm_limit >= 600 && this.rpm_limit <= 10000
      this.$emit('rpmExcessiveValid', validRpmExcessiveValues)
    }
  },
  mounted() {
    this.$emit('rpmExcessive', this.rpm_limit)
  },
  watch: {
    editMode(newValue) {
      if (!newValue && this.dataProp !== undefined) {
        this.rpm_limit = this.dataProp
      }
    }
  },
  created() {
    if (this.$route.name !== 'agent-create' && this.dataProp !== undefined) {
      this.rpm_limit = this.dataProp
    }
  }
}
</script>